/* ==========================================================================
   eg-lymph-faq — the FAQ accordion; each item opens on its own.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lffqInit === 'true') return;
    root.dataset.lffqInit = 'true';

    Array.prototype.forEach.call(root.querySelectorAll('[data-lffq-item]'), function (item) {
      var toggle = item.querySelector('[data-lffq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lffq]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
